var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"next-page d-flex align-items-center"},[_c('img',{attrs:{"src":"/icons/down.png"},on:{"click":_vm.submit}}),_c('p',[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }